import { useState } from "react";
import { Typography, Pressable } from "@repo/design-system";
import {
  TheProject,
  BlueprintViruses,
  Methodology,
  Publications,
} from "./_components";

type HomeTab = "project" | "viruses" | "methodology" | "publications";

const TABS: { id: HomeTab; label: string }[] = [
  { id: "project", label: "The Project" },
  { id: "viruses", label: "Blueprint Viruses" },
  { id: "methodology", label: "Methodology" },
  { id: "publications", label: "Publications" },
];

export function HomePage() {
  const [activeTab, setActiveTab] = useState<HomeTab>("project");

  return (
    <div className="flex min-h-[calc(100vh-6rem)] items-center justify-center bg-backgroundPrimary px-4 py-6 md:px-8 md:py-10">
      <div className="flex h-[78vh] w-3/4 flex-col overflow-hidden rounded-2xl border border-borderPrimary shadow-medium">
        <div className="flex overflow-x-auto bg-n900 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {TABS.map((tab) => (
            <Pressable
              key={tab.id}
              onPress={() => setActiveTab(tab.id)}
              className={`flex-shrink-0 cursor-pointer whitespace-nowrap px-7 py-4 transition-colors focus:outline-none ${
                activeTab === tab.id ? "bg-backgroundPrimary" : "hover:bg-n700"
              }`}>
              <Typography
                variant="paragraph-l-semibold"
                className={
                  activeTab === tab.id ? "text-contentBrand" : "text-white"
                }>
                {tab.label}
              </Typography>
            </Pressable>
          ))}
        </div>

        <div className="flex-1 overflow-y-auto bg-backgroundPrimary p-8">
          {activeTab === "project" && <TheProject />}
          {activeTab === "viruses" && <BlueprintViruses />}
          {activeTab === "methodology" && <Methodology />}
          {activeTab === "publications" && <Publications />}
        </div>
      </div>
    </div>
  );
}
